// Slide data configuration — with chapter groupings for the top-nav
export const baseSlides = [
  { id: "welcome",      title: "Welcome",            pillar: "all",         chapter: "overview" },
  { id: "who-we-are",   title: "Who We Are",         pillar: "all",         chapter: "overview" },
  { id: "problem",      title: "The Problem",        pillar: "all",         chapter: "overview" },
  { id: "pillars",      title: "Our 4 Pillars",      pillar: "all",         chapter: "way" },
  { id: "fast",         title: "FAST",               pillar: "fast",        chapter: "way" },
  { id: "lean",         title: "LEAN",               pillar: "lean",        chapter: "way" },
  { id: "personal",     title: "PERSONAL",           pillar: "personal",    chapter: "way" },
  { id: "intelligent",  title: "INTELLIGENT",        pillar: "intelligent", chapter: "way" },
  { id: "stack",        title: "Our Stack",          pillar: "all",         chapter: "platform" },
  { id: "commercial",   title: "Commercial Model",   pillar: "all",         chapter: "commercial" },
  { id: "demos",        title: "Explore Demos",      pillar: "all",         chapter: "demos" },
];

// Legacy numbered slides export for compatibility
export const slides = baseSlides.map((s, i) => ({ ...s, numId: i }));

export const pillarColors = {
  fast: "#FFD700",
  lean: "#10B981",
  personal: "#A855F7",
  intelligent: "#3B82F6",
  all: "#64748B",
  airline: "#F59E0B",
};

export const pillarData = {
  fast: { name: "FAST", complement: "MEDIA", color: "#FFD700" },
  lean: { name: "LEAN", complement: "PLATFORM", color: "#10B981" },
  personal: { name: "PERSONAL", complement: "ENTERTAINMENT", color: "#A855F7" },
  intelligent: { name: "INTELLIGENT", complement: "ENGAGEMENT", color: "#3B82F6" },
};

// Chapters displayed in the top-nav
export const chapters = [
  { id: "overview",   label: "Overview" },
  { id: "way",        label: "The Aeroplay Way" },
  { id: "platform",   label: "Our Platform" },
  { id: "delivery",   label: "Delivery" },
  { id: "creative",   label: "Creative" },
  { id: "commercial", label: "Commercial" },
  { id: "demos",      label: "Explore Demos" },
];

// Which chapter should an airline-specific extra slide belong to?
// Naming conventions used by CX/BI/SQ:
//   *-team, *-services  → delivery
//   *-creativity        → creative
//   *-commercials       → commercial
const guessAirlineChapter = (id) => {
  if (/-team$|-services$/.test(id)) return "delivery";
  if (/-creativity$/.test(id))       return "creative";
  if (/-commercials$/.test(id))      return "commercial";
  return "airline";
};

// Build slide list for a given airline config
export const getSlidesForAirline = (airline) => {
  if (airline.slideOrder) {
    const extras = Object.fromEntries((airline.extraSlides || []).map((s) => [s.id, s]));
    const base = Object.fromEntries(baseSlides.map((s) => [s.id, s]));
    return airline.slideOrder
      .map((id) => (extras[id] ? { pillar: "airline", ...extras[id] } : base[id]))
      .filter(Boolean);
  }
  const hideIds = airline.hideSlides || [];
  // Split base slides into "before demos" and demos so we can insert extras before demos.
  const filtered = baseSlides.filter((s) => !hideIds.includes(s.id));
  const beforeDemos = filtered.filter((s) => s.id !== "demos");
  const demosSlide  = filtered.find((s) => s.id === "demos");
  const extras = (airline.extraSlides || []).map((s) => ({
    ...s,
    pillar:  s.pillar  || "airline",
    chapter: s.chapter || guessAirlineChapter(s.id),
  }));
  return demosSlide ? [...beforeDemos, ...extras, demosSlide] : [...beforeDemos, ...extras];
};
